
// function specify for turning persian letters (also its lagacy) and turning them to valid english without any changes
export default function persianToLatinDigits(input) {
    const persianDigits = '۰۱۲۳۴۵۶۷۸۹';
    const latinDigits = '0123456789';

    let output = '';
    for (let i = 0; i < input.length; i++) {
        const index = persianDigits.indexOf(input[i]);
        if (index !== -1) {
            output += latinDigits[index];
        } else {
            output += input[i];
        }
    }
    return output;
}